import { trpc } from '@/utils/trpc'

type Params = {
  boardId: string
  enabled?: boolean
}
export const useBoardPreview = ({ boardId, enabled }: Params) => {
  const { data: preview } = trpc.boardPreview.useQuery(
    {
      boardId,
    },
    {
      enabled: enabled ?? true,
    },
  )
  const utils = trpc.useUtils()
  const invalidate = (boardId: string) => utils.boardPreview.invalidate({ boardId }, { refetchType: 'all' })

  return {
    preview,
    invalidate,
  }
}
